import { UI } from '@/Components/UI';
import { useDynamicInputs } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export const TagsForm = () => {
    const { t } = useTranslation(['recipes']);
    const { addValue, removeValue, values } = useDynamicInputs('tags', { name: '' });

    useEffect(() => {
        if (!values || values.length === 0) {
            addValue();
        }
    }, [values]);

    return (
        <>
            <UI.Heading level={2}>
                {t('form.tags.heading')}
            </UI.Heading>

            <div className={'flex flex-col gap-2 mb-2'}>
                {values?.map((_, index) => (
                    <div
                        key={index}
                        className={'px-4 py-2 rounded-lg border border-primary'}>
                        <div className={'col-span-2 text-end'}>
                            <UI.Button
                                buttonStyle={'tonal'}
                                type={'button'}
                                onClick={() => removeValue(index)}>
                                <UI.Icon name={'delete'} />
                            </UI.Button>
                        </div>

                        <UI.Form.Input
                            name={`tags.${index}.name`}
                            label={t('form.tags.tag')} />
                    </div>
                ))}

                <UI.Button
                    buttonStyle={'tonal'}
                    type={'button'}
                    onClick={addValue}>
                    <UI.Icon name={'add'} />
                </UI.Button>
            </div>
        </>
    );
};
